// src/components/Dashboard.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React, { useState, useRef, useEffect } from 'react';
import { Container, Badge, Dropdown, Image, Offcanvas } from 'react-bootstrap';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import ChatBell from './chat/ChatBell'; // <-- НОВЫЙ ИМПОРТ
import { useNotifications } from '../contexts/NotificationContext';
import { useChat } from '../contexts/ChatContext'; // <-- НОВЫЙ ИМПОРТ
import { useAuth } from '../contexts/AuthContext';

const APP_VERSION = __APP_VERSION__;

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { unreadCount } = useNotifications();
  const { totalUnreadCount } = useChat(); // <-- НОВЫЙ ХУК для непрочитанных сообщений
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const userMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const currentYear = new Date().getFullYear();

  // Закрытие меню при клике вне его области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/_admin/profile' || path === '/_admin/') return 'profile';
    if (path === '/_admin/users') return 'users';
    if (path === '/_admin/notifications') return 'notifications';
    if (path === '/_admin/tasks') return 'tasks';
    if (path === '/_admin/chat') return 'chat';
    return 'profile';
  };

  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case 'admin': return 'danger';
      case 'moderator': return 'warning';
      default: return 'secondary';
    }
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'admin': return 'bi-star-fill';
      case 'moderator': return 'bi-shield-check';
      default: return 'bi-person';
    }
  };

  const getInitials = () => {
    const firstName = user?.telegram_first_name || '';
    const lastName = user?.telegram_last_name || '';
    
    if (firstName || lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    
    if (user?.name) {
      return user.name
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
        .substring(0, 2);
    }
    
    return 'U';
  };

  const getFullName = () => {
    const firstName = user?.telegram_first_name || '';
    const lastName = user?.telegram_last_name || '';
    
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    } else if (firstName) {
      return firstName;
    } else if (lastName) {
      return lastName;
    }
    
    return user?.name || 'Пользователь';
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleLogout = () => {
    setShowUserMenu(false);
    setShowMobileMenu(false);
    logout();
  };

  const handleNavigation = (path) => {
    navigate(path);
    setShowMobileMenu(false);
  };

  if (!user) {
    return null;
  }

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      {/* Header */}
      <header className="dashboard-header bg-white border-bottom">
        <Container fluid className="px-3 px-lg-4">
          <div className="d-flex justify-content-between align-items-center py-2">
            
            {/* ЛЕВАЯ ЧАСТЬ */}
            <div className="d-flex align-items-center">
              {/* Кнопка мобильного меню */}
              <button
                className="mobile-menu-btn btn btn-link text-dark p-2 me-2 d-lg-none"
                onClick={toggleMobileMenu}
                aria-label="Открыть меню"
              >
                <i className="bi bi-list fs-5"></i>
              </button>

              {/* Логотип */}
              <div className="d-flex align-items-center">
                <div className="logo-placeholder">
                  Тт
                </div>
                <div className="d-none d-md-block ms-3">
                  <h1 className="h5 mb-0 text-primary fw-bold">ТаскИТ</h1>
                  <small className="text-muted">
                    {user.role === 'admin' ? 'Административная панель' : 
                       user.role === 'moderator' ? 'Административная панель' : 'Менеджер задач'}
                  </small>
                </div>
              </div>
            </div>

            {/* ЦЕНТРАЛЬНАЯ ЧАСТЬ - НАВИГАЦИЯ ДЛЯ ДЕСКТОПА */}
            <nav className="d-none d-lg-flex align-items-center mx-4 flex-grow-1 justify-content-center">
              <div className="d-flex align-items-center gap-1">
                <button
                  onClick={() => handleNavigation('/_admin/profile')}
                  className={`nav-header-btn ${getActiveTab() === 'profile' ? 'active' : ''}`}
                >
                  <i className="bi bi-person me-2"></i>
                  Профиль
                </button>
                
                <button
                  onClick={() => handleNavigation('/_admin/tasks')}
                  className={`nav-header-btn ${getActiveTab() === 'tasks' ? 'active' : ''}`}
                >
                  <i className="bi bi-list-task me-2"></i>
                  Задачи
                </button>
                
                <button
                  onClick={() => handleNavigation('/_admin/users')}
                  className={`nav-header-btn ${getActiveTab() === 'users' ? 'active' : ''}`}
                >
                  <i className="bi bi-people me-2"></i>
                  Пользователи
                </button>

                <button
                  onClick={() => handleNavigation('/_admin/chat')}
                  className={`nav-header-btn ${getActiveTab() === 'chat' ? 'active' : ''}`}
                >
                  <i className="bi bi-chat me-2"></i>
                  Сообщения
                </button>

              </div>
            </nav>

            {/* ПРАВАЯ ЧАСТЬ */}
            <div className="d-flex align-items-center gap-2 gap-md-3">
              
          
              
              {/* ИКОНКИ ДЛЯ МОБИЛЬНЫХ */}
              <div className="d-md-none d-flex align-items-center gap-2">
                <ChatBell isMobile={true} />
                <NotificationBell isMobile={true} />
              </div>
              
              {/* АВАТАР ПОЛЬЗОВАТЕЛЯ */}
              <div className="position-relative" ref={userMenuRef}>
                <button
                  onClick={toggleUserMenu}
                  className="user-avatar-btn d-flex align-items-center gap-2 border-0 bg-transparent p-2 rounded-3"
                >
                  <div className="position-relative">
                    {user.telegram_photo_url ? (
                      <img 
                        src={user.telegram_photo_url} 
                        alt="Avatar"
                        className="user-avatar-img"
                      />
                    ) : (
                      <div className="user-avatar-placeholder">
                        {getInitials()}
                      </div>
                    )}
                    
                    <div 
                      className={`user-role-badge ${user.role}`}
                      title={user.role === 'admin' ? 'Администратор' : 
                             user.role === 'moderator' ? 'Модератор' : 'Пользователь'}
                    >
                      <i className={getRoleIcon(user.role)}></i>
                    </div>
                  </div>
                  
                  <div className="d-none d-xl-block text-start">
                    <div className="fw-semibold" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>
                      {getFullName()}
                    </div>
                    <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                      {user.role === 'admin' ? 'Администратор' : 
                       user.role === 'moderator' ? 'Модератор' : 'Пользователь'}
                    </small>
                  </div>
                  
                  <i 
                    className={`bi bi-chevron-down text-muted d-none d-md-block ${
                      showUserMenu ? 'rotate-180' : ''
                    }`}
                    style={{ transition: 'transform 0.3s ease' }}
                  ></i>
                </button>

                {/* Выпадающее меню пользователя */}
                {showUserMenu && (
                  <div 
                    className="position-absolute bg-white rounded-3 shadow-lg border mt-2 user-dropdown-menu"
                    style={{
                      top: '100%',
                      right: '0',
                      minWidth: '260px',
                      zIndex: 1050,
                      animation: 'fadeInDown 0.2s ease-out'
                    }}
                  >
                    {/* Заголовок */}
                    <div className="p-4 border-bottom bg-light rounded-top-3">
                      <div className="fw-bold text-dark mb-1">{getFullName()}</div>
                      <div className="text-muted small mb-2">
                        {user.role === 'admin' ? 'Администратор' : 
                         user.role === 'moderator' ? 'Модератор' : 'Пользователь'}
                      </div>
                      <div className="text-primary small">
                        <i className="bi bi-envelope me-1"></i>
                        {user.email || 'Email не указан'}
                      </div>
                    </div>
                    
                    {/* Пункты меню */}
                    <div className="p-3">
                      <button
                        className="dropdown-item w-100 text-start border-0 bg-transparent p-3 rounded d-flex align-items-center gap-3"
                        onClick={() => {
                          setShowUserMenu(false);
                          handleNavigation('/_admin/profile');
                        }}
                      >
                        <i className="bi bi-person-fill text-primary fs-5" style={{ width: '20px' }}></i>
                        <div>
                          <div className="fw-medium">Мой профиль</div>
                          <small className="text-muted">Управление профилем</small>
                        </div>
                      </button>
                      
                      <button
                        className="dropdown-item w-100 text-start border-0 bg-transparent p-3 rounded d-flex align-items-center gap-3"
                        onClick={() => {
                          setShowUserMenu(false);
                          handleNavigation('/_admin/chat') // <-- Добавляем чат в меню
                        }}
                      >
                        <i className="bi bi-chat-fill text-primary fs-5" style={{ width: '20px' }}></i>
                        <div>
                          <div className="fw-medium">Сообщения</div>
                          <small className="text-muted">
                            {totalUnreadCount > 0 ? `${totalUnreadCount} непрочитанных` : 'Нет новых сообщений'}
                          </small>
                        </div>
                      </button>

                      <button
                        className="dropdown-item w-100 text-start border-0 bg-transparent p-3 rounded d-flex align-items-center gap-3"
                        onClick={() => {
                          setShowUserMenu(false);
                          handleNavigation('/_admin/settings');
                        }}
                      >
                        <i className="bi bi-gear-wide-connected text-primary fs-5" style={{ width: '20px' }}></i>
                        <div>
                          <div className="fw-medium">Настройки</div>
                          <small className="text-muted">Настройки системы</small>
                        </div>
                      </button>

                      <button
                        className="dropdown-item w-100 text-start border-0 bg-transparent p-3 rounded d-flex align-items-center gap-3"
                        onClick={() => {
                          setShowUserMenu(false);
                          console.log('Settings clicked');
                        }}
                      >
                        <i className="bi bi-info-circle-fill text-primary fs-5" style={{ width: '20px' }}></i>
                        <div>
                          <div className="fw-medium">Справка</div>
                          <small className="text-muted">Информация о системе</small>
                        </div>
                      </button>

                      <hr className="my-2" />
                      
                      <button
                        className="dropdown-item w-100 text-start border-0 bg-transparent p-3 rounded d-flex align-items-center gap-3 text-danger"
                        onClick={handleLogout}
                      >
                        <i className="bi bi-box-arrow-right fs-5" style={{ width: '20px' }}></i>
                        <div>
                          <div className="fw-medium">Выход</div>
                          <small className="text-muted">Завершить сеанс</small>
                        </div>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </header>

      {/* МОБИЛЬНОЕ МЕНЮ */}
      <Offcanvas 
        show={showMobileMenu} 
        onHide={() => setShowMobileMenu(false)}
        placement="start"
        className="mobile-sidebar"
        ref={mobileMenuRef}
      >
        <Offcanvas.Header closeButton className="mobile-sidebar-header">
          <Offcanvas.Title>
            <div className="d-flex align-items-center">
              <div className="logo-placeholder me-3">
                Тт
              </div>
              <div>
                <h6 className="mb-0 text-primary fw-bold">ТаскИТ</h6>
                <small className="text-muted">
                  {user.role === 'admin' ? 'Админ панель' : 
                    user.role === 'moderator' ? 'Админ панель' : 'Менеджер задач'}
                </small>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mobile-sidebar-body">
          <div className="d-flex flex-column gap-1 mb-4">
            <button
              onClick={() => handleNavigation('/_admin/profile')}
              className={`nav-mobile-sidebar-btn ${getActiveTab() === 'profile' ? 'active' : ''}`}
            >
              <i className="bi bi-person"></i>
              <span>Профиль</span>
            </button>
            
            <button
              onClick={() => handleNavigation('/_admin/tasks')}
              className={`nav-mobile-sidebar-btn ${getActiveTab() === 'tasks' ? 'active' : ''}`}
            >
              <i className="bi bi-list-task"></i>
              <span>Задачи</span>
            </button>
            
            <button
              onClick={() => handleNavigation('/_admin/users')}
              className={`nav-mobile-sidebar-btn ${getActiveTab() === 'users' ? 'active' : ''}`}
            >
              <i className="bi bi-people"></i>
              <span>Пользователи</span>
            </button>
            
            <button
              onClick={() => handleNavigation('/_admin/chat')}
              className={`nav-mobile-sidebar-btn ${getActiveTab() === 'chat' ? 'active' : ''}`}
            >
              <i className="bi bi-chat"></i>
              <span>Сообщения</span>
              {totalUnreadCount > 0 && (
                <Badge bg="danger" className="notification-badge">
                  {totalUnreadCount > 99 ? '99+' : totalUnreadCount}
                </Badge>
              )}
            </button>
          </div>
          
          <div className="mt-auto pt-4 border-top">
            <div className="d-flex align-items-center gap-3 mb-4 p-3 bg-light rounded-3">
              {user.telegram_photo_url ? (
                <img 
                  src={user.telegram_photo_url} 
                  alt="Avatar"
                  className="user-avatar-img"
                  style={{ width: '48px', height: '48px' }}
                />
              ) : (
                <div 
                  className="user-avatar-placeholder"
                  style={{ width: '48px', height: '48px' }}
                >
                  {getInitials()}
                </div>
              )}
              <div className="flex-grow-1">
                <div className="fw-semibold">{getFullName()}</div>
                <small className="text-muted">
                  {user.role === 'admin' ? 'Администратор' : 
                   user.role === 'moderator' ? 'Модератор' : 'Пользователь'}
                </small>
              </div>
            </div>
            <button
              className="btn btn-outline-danger w-100 btn-sm py-2"
              onClick={handleLogout}
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Выход из системы
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Content */}
      <main className="dashboard-content flex-grow-1">
        <Container fluid className="py-4 px-3 px-lg-4">
          <Outlet />
        </Container>
      </main>

      {/* Footer */}
      <footer className="bg-white border-top py-3 mt-auto">
        <Container fluid className="px-3 px-lg-4">
          <div className="text-center">
            <p className="text-muted small mb-0">
              <a href="https://hakster.ru/" target="_blank">HAKSTER</a> & WASKED | {currentYear} ТаскИТ | TaskIT <small className="text-muted">v{APP_VERSION}</small> 
            </p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default Dashboard;